import React from 'react'
import { MAIN, SLIDER, STRIPE, HIGHLIGHT, ADVERTISEMENT } from '../../constants/programSectionTypes'
import SelectionPageContainer from '../../containers/PageEditSelection/SelectionPageContainer'

const PageEditSelection = ({selectionId, selectionType, hasWeischerActive, hasAdvertisementsActive}) => {
    if(MAIN === selectionType) {
        return <SelectionPageContainer
            selectionType={selectionType}
            selectionId={selectionId}
            displayMovies={true}
            displayHighlights={false}
            displayAds={true}
            displayAdvertisements={hasAdvertisementsActive}
            displayWeischer={hasWeischerActive}
            defaultAllOpen={true}
            toogleAllOpenButtons={true}
        />
    } else if(SLIDER === selectionType) {
        return <SelectionPageContainer
            selectionType={selectionType}
            selectionId={selectionId}
            displayMovies={true}
            displayHighlights={false}
            displayAds={true}
            displayAdvertisements={false}
            defaultAllOpen={true}
            toogleAllOpenButtons={false}
        />
    } else if(STRIPE === selectionType) {
        return <SelectionPageContainer
            selectionType={selectionType}
            selectionId={selectionId}
            displayMovies={true}
            displayHighlights={false}
            displayAds={false}
            displayAdvertisements={false}
            defaultAllOpen={true}
            toogleAllOpenButtons={false}
        />
    } else if(HIGHLIGHT=== selectionType) {
        return <SelectionPageContainer
            selectionType={selectionType}
            selectionId={selectionId}
            displayMovies={false}
            displayHighlights={true}
            displayAds={false}
            displayAdvertisements={false}
            defaultAllOpen={true}
            toogleAllOpenButtons={false}
        />
    } else if(ADVERTISEMENT=== selectionType) {
        return <SelectionPageContainer
            selectionType={selectionType}
            selectionId={selectionId}
            displayMovies={false}
            displayHighlights={false}
            displayAds={false}
            displayAdvertisements={hasAdvertisementsActive}
            defaultAllOpen={true}
            toogleAllOpenButtons={false}
        />
    } else {
        return <div>Component under development</div>
    }
}

export default PageEditSelection